import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <section className="w-full bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-57">
      <div className="max-w-5xl mx-auto" data-id="element-58">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#4C1D95] mb-10" data-id="element-59">
          ¿Es para ti?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12" data-id="element-60">
          {/* For You */}
          <div className="bg-[#F5F0E6] p-6 sm:p-8 rounded-2xl border border-[#84CC16]/30" data-id="element-61">
            <h3 className="text-xl font-bold text-[#4C1D95] mb-4 flex items-center" data-id="element-62">
              <span className="bg-[#84CC16] text-white p-1 rounded-full mr-3" data-id="element-63">
                <Check className="w-4 h-4" data-id="element-64" />
              </span>
              SÍ, si...
            </h3>
            <ul className="space-y-3" data-id="element-65">
              {['Tienes una lesión activa o recurrente.', 'Quieres moverte sin dolor al día siguiente.', 'Estás harto de improvisar y recaer.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-66">
                  <Check className="w-5 h-5 text-[#84CC16] mr-3 mt-0.5 flex-shrink-0" data-id="element-67" />
                  <span className="text-[#444444]" data-id="element-68">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-gray-50 p-6 sm:p-8 rounded-2xl border border-gray-200" data-id="element-69">
            <h3 className="text-xl font-bold text-[#4C1D95] mb-4 flex items-center" data-id="element-70">
              <span className="bg-[#7C3AED] text-white p-1 rounded-full mr-3" data-id="element-71">
                <X className="w-4 h-4" data-id="element-72" />
              </span>
              NO, si buscas...
            </h3>
            <ul className="space-y-3" data-id="element-73">
              {['Protocolos de sustancias o fármacos.', 'Una "cura mágica" en 24 horas.', 'Resultados sin medir ni registrar nada.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-74">
                  <X className="w-5 h-5 text-[#7C3AED] mr-3 mt-0.5 flex-shrink-0" data-id="element-75" />
                  <span className="text-[#444444]" data-id="element-76">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}